let guestFields = [];
let headerGuestFields = [];

/**
 * Set guest specific field meta for the client
 */
export function setGuestFields(newGuestFields, newHeaderGuestFields) {
    guestFields = newGuestFields;
    headerGuestFields = newHeaderGuestFields;
}

/**
 * Grab guest fields and header guest fields
 * @returns {[][]}
 */
export function useGuestFields() {
    // just return a plain list of objects (and 2 fake parameters)
    return [guestFields, headerGuestFields];
}
